import { getLocalizedValue } from "../getLocalizedValue";
import {
  COUNTRY_ISO_2_NAME,
  COUNTRY_ISO_2_NAME_JA,
  COUNTRY_TICKER_2_LINK,
} from "./countries";
import { Locale } from "~constants/i18n";

const IS_DEV = process.env.NODE_ENV === "development";

// Locale-specific country ISO name maps
const COUNTRY_ISO_2_NAME_LOCALE_CONFIGS: Record<
  Locale,
  Record<string, string>
> = {
  [Locale.En]: COUNTRY_ISO_2_NAME,
  [Locale.Ja]: COUNTRY_ISO_2_NAME_JA,
};

export function getCountryIso2Name(
  countryIso: string | null,
  locale: string = Locale.En
) {
  const iso = countryIso?.toUpperCase() || null;

  return getLocalizedValue(
    iso,
    COUNTRY_ISO_2_NAME_LOCALE_CONFIGS,
    locale as Locale,
    iso || ""
  );
}

export function countryTicker2Link(countryTicker: string) {
  const countryUrl = COUNTRY_TICKER_2_LINK[countryTicker] || "";

  if (IS_DEV) {
    // add bazaar page prefix only for dev
    return `/section-front/${countryUrl}`;
  }

  // on non dev environment use envoy route prefix
  return `/markets/${countryUrl}`;
}
